import { Injectable } from '@angular/core';
import type { ID } from '@clean-code/models/common';
import type { Field } from 'devextreme/ui/pivot_grid/data_source';
import { BehaviorSubject, type Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PivotTableService {
  private pivotTableSubject = new Subject<Array<Field>>();
  private refreshTable = new BehaviorSubject<boolean>(false);
  private idColumnName = new BehaviorSubject<IdColumnName | null>(null);

  pivotTableObservable: Observable<Array<Field>> =
    this.pivotTableSubject.asObservable();

  refreshTableObservable: Observable<boolean> =
    this.refreshTable.asObservable();

  idColumnNameObservable: Observable<IdColumnName> =
    this.idColumnName.asObservable();

  setPivotTableData(data: Array<Field>) {
    this.pivotTableSubject.next(data);
  }

  setRefreshTable(doRefresh: boolean) {
    this.refreshTable.next(doRefresh);
  }

  setIdAndColumnName(timeSeriesId: ID, columnName: string) {
    const obj: IdColumnName = {
      timeSeriesId: timeSeriesId,
      columnName: columnName,
    };
    this.idColumnName.next(obj);
  }
}

export interface IdColumnName {
  timeSeriesId: ID;
  columnName: string;
}
